'use client';

import { X } from 'lucide-react';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import { useState } from 'react';

type VideoEmbed = Record<string, any>;

type VideoPrivacy = Record<string, any>;

type VideoPictures = Record<string, any>;

type VideoStats = Record<string, any>;

type VideoUploader = Record<string, any>;

type VideoMetadata = Record<string, any>;

type VideoParentFolder = Record<string, any>;

type VideoReviewPage = Record<string, any>;

type VideoApp = Record<string, any>;

type VideoPlay = Record<string, any>;

type VideoUpload = Record<string, any>;

type VideoTranscode = Record<string, any>;

type VideoFile = {
    [key: string]: any;
};

export type Video = {
    uri: string;
    name: string;
    description: string | null;
    type: string;
    link: string;
    player_embed_url: string;
    duration: number;
    width: number;
    language: string;
    height: number;
    embed: VideoEmbed;
    created_time: string;
    modified_time: string;
    release_time: string;
    content_rating: string[];
    content_rating_class: string;
    rating_mod_locked: boolean;
    license: string | null;
    privacy: VideoPrivacy;
    pictures: VideoPictures;
    tags: string[];
    stats: VideoStats;
    categories: string[];
    uploader: VideoUploader;
    metadata: VideoMetadata;
    manage_link: string;
    user: Record<string, any>;
    last_user_action_event_date: string;
    parent_folder: VideoParentFolder;
    review_page: VideoReviewPage;
    files: VideoFile[];
    download: VideoFile[];
    app: VideoApp;
    play: VideoPlay;
    status: string;
    resource_key: string;
    upload: VideoUpload;
    transcode: VideoTranscode;
    is_playable: boolean;
    has_audio: boolean;
};

interface VideoProps {
    video: Video;
}

const VideoComponent = (props: VideoProps) => {
    const { video } = props;
    const t = useTranslations();
    const [openedPopup, setOpenedPopup] = useState(false);
    return (
        <>
            <article className="group flex flex-col gap-4 transition-all ease-in-out duration-300">
                <div className="relative">
                    <Image
                        alt={video.name}
                        src={video.pictures?.sizes[4]?.link}
                        width={video.pictures?.sizes[4]?.width}
                        height={video.pictures?.sizes[4]?.height}
                        className="rounded-lg object-cover w-full"
                    />
                    <div className="hidden group-hover:flex absolute inset-0 w-full h-full bg-black/30">
                        <button
                            onClick={() => setOpenedPopup(true)}
                            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2  text-tofu font-tradeGothic font-bold uppercase px-10 py-2 rounded-lg text-6xl"
                        >
                            {t('Explore.watch')}
                        </button>
                        <p className="absolute left-0 right-0 bottom-4 mx-auto w-fit text-white font-helveticaNeue font-light text-lg text-center">
                            {video.description?.slice(0, 40)
                                ? `${video.description?.slice(0, 40)}...`
                                : ''}
                        </p>
                    </div>
                </div>
                <h2 className="group-hover:text-primary font-tradeGothic font-bold text-[28px] md:text-6xl uppercase leading-none">
                    {video.name}
                </h2>
            </article>
            {openedPopup && (
                <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-50">
                    <div className="absolute inset-0 m-auto max-w-[95vw] h-fit bg-black p-2 md:p-10">
                        <div className="absolute -top-10 md:top-5 right-0 md:right-5 text-black">
                            <button onClick={() => setOpenedPopup(false)} className="text-white">
                                <X size={30} />
                            </button>
                        </div>
                        <div>
                            <div
                                className="w-full [&>iframe]:w-full [&>iframe]:h-[calc(100vw*0.5625)]"
                                dangerouslySetInnerHTML={{ __html: video.embed?.html }}
                            />
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default VideoComponent;
